'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemActiveNarrow = require('./commonMenuItemActiveNarrow');

var _commonMenuItemActiveNarrow2 = _interopRequireDefault(_commonMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Active menu item for N and XN breakpoints
 * @constructor
 */
function PrimaryMenuItemActiveNarrow() {
  _commonMenuItemActiveNarrow2.default.prototype.constructor.apply(this, arguments);
} /**
   * @module navigation/primaryMenuItemActiveNarrow
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

PrimaryMenuItemActiveNarrow.prototype = (0, _create2.default)(_commonMenuItemActiveNarrow2.default.prototype);

exports.default = PrimaryMenuItemActiveNarrow;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/primaryMenuItemActiveNarrow.js
// module id = 1802
// module chunks = 1